function Propagate() {
  return (
    <div className="Propagate">
      <h1>Propagate page</h1>
    </div>
    // practice commit
  );
}

export default Propagate;
